define('views/pages/account/AccountProfileView',['underscore', 'jquery', 'app',
        'views/pages/account/AccountView',
        'views/blocks/AddressIconAliasSelectorView',
        'AddressAutocompleteView',
        'TagCommander',
        'InternalLinkView',
        'models/AddressModel',
        'template!blocks/account/profile',
        'template!blocks/account/profile-hobby',
        'template!blocks/account/address-line',
        'InputView',
        'InputPhoneView',
        'SelectView',
        'moment',
        'validatorNIF',
        'phoneUtils',
    ],
    function (_, $, app,
              AccountView,
              AddressIconAliasSelectorView,
              AddressAutocompleteView,
              TagCommander,
              InternalLinkView,
              AddressModel,
              profileTemplate,
              profileHobbyTemplate,
              addressLineTemplate,
              InputView,
              InputPhoneView,
              SelectView,
              moment,
              validatorNIF,
              phoneUtils
              ) {

        //
        // Account Profile View
        // représente la profile de la page mon compte
        //

        var view,
            inputPhone,
            addressAutocompleteView;

        function getAddressFromEvent(e){
            e.preventDefault();
            e.stopPropagation();
            var id_address = $(e.currentTarget).closest('.address-line').data('id_address').toString();
            return app.getAddress(id_address, true);
        }

        return AccountView.extend({

            events: {
                'click .password-reset': 'resetPassword',
                'click .submit-address': 'onSubmitAddress',
                'click .cancel-address': 'onCancelAddress',
                'click .profile-infos .edit-infos': 'toggleInfos',
                'submit .form-infos': 'infosFormSubmit',
                'click .hobbies .edit-infos': 'toggleHobbies',
                'click .btn-alert-sms, .btn-newsletter': 'toggleOptin',
                'click .hobbies form button': 'submitHobbies',
                'click .edit-shop': 'toggleShop',
                'click .stores button[type="submit"]': 'submitShop',
                'click .mod-d-m-l-m': 'newAddress',
                'click .address-line .delete-tab': 'addressDelete',
                'click .address-line .delivery-address-alias': 'clickDeliveryAddressAlias',
                'submit .address-line .update-address-data': 'submitAddressData',
            },

            initialize: function () {

                view = this;
                AccountView.prototype.initialize.apply(view, arguments);

                var customer = app.getCustomer(),
                    addresses = app.getAddresses();

                view.render();
                view.listenTo(addresses, 'add undelete', view.addressAdd);
                view.listenTo(addresses, 'change', view.addressChange);
                view.listenTo(addresses, 'error fail', view.addressError);
                view.listenTo(addresses, 'destroy', view.addressDestroy);

                view.listenTo(customer, 'change:id_address_primary', view.updateAddressPrimary);
                view.listenTo(customer, 'change:phone', view.updatePhone);
                view.listenTo(customer, 'change:marital_status', view.updateMaritalStatus);
                view.listenTo(customer, 'change:children', view.updateChildren);
                view.listenTo(customer, 'change:shopLike', view.updateStore);
                view.listenTo(customer, 'change:tax_indentification_number', view.updateTaxIdentificationNumber);
                view.listenTo(customer, 'change:birthday', view.updateBirthday);
                view.listenTo(customer, 'change:firstname change:lastname', view.updateCustomerName);
                view.listenTo(customer, 'passwordUpdateSuccess', view.passwordUpdateSuccess);
                view.listenTo(customer.getPrimaryAddress(), 'change', view.changeAddressPrimary);

                customer.getHobbies().each(function (hobby) {
                    view.listenTo(customer, 'change:' + hobby.slug, view.onHobbyChange);
                });

                view.updateNoAddress();
            },
            afterInitialize:function(){
                view.render();
            },
            render: function () {
                var view = this,
                    customer = app.getCustomer(),
                    store = customer.getStore(),
                    addresses = _(app.getAddresses().where({deleted: 0})),
                    customerAddress = customer.getPrimaryAddress() || new AddressModel({id_address: 'new'});
                //
                view.$el.html(profileTemplate({
                    customer: customer,
                    addresses: addresses,
                    stores: app.getStores().getStoreExistInNeolane(),
                    store: store ? store : false,
                    newAddress: customerAddress
                }));
                view.addressAutocomplete = view.attachView(new AddressAutocompleteView({
                    el: view.$('.address-autocomplete-input').get(0),
                    type: 'address',
                    theme: 'form-field',
                    action: 'edit',
                    autoSubmit: false,
                    displayDelay: false,
                    initialAddress: customerAddress
                }));
                view.listenTo(view.addressAutocomplete, 'selectAutocompleteLine', view.selectAutocompleteLine);

                if(!customer.getHobbies().findWhere({checked:true})){
                    view.toggleHobbies();
                }

                InternalLinkView.initializeLinksOfView(view);
                view.attachViews(InputPhoneView.initializeInputsOfView(view));
                view.attachViews(InputView.initializeInputsOfView(view));
                view.attachViews(SelectView.initializeSelectsOfView(view));
                view.delegateEvents();
                // fixing date format
                view.$('[name=birthday]').val(app.getCustomer().formatBirthday('L'));

            },
            keyAction: function (e) {
                var code = e.keyCode || e.which;
                if (code == 13) {
                    this.onSubmitAddress(e);
                }
            },
            onSubmitAddress: function (e) {
                e.preventDefault();
                var addressLine = $(e.currentTarget).closest('.address-line'),
                    id_address = addressLine.data('id_address').toString(),
                    address = app.getAddress(id_address),
                    newVal = addressLine.find('.input-title').val(),
                    data = addressLine.find('.input-data').val();
                addressLine.removeClass('editable');
                addressLine.find('.title').text(newVal);
                addressLine.find('.address-data').text(data);
                address.save({alias: newVal, data: data});
            },
            onCancelAddress: function (e) {
                e.preventDefault();
                var addressLine = $(e.currentTarget).closest('.address-line');
                addressLine.removeClass('editable');
            },
            selectAutocompleteLine: function (addressAutocompleteModel) {
                var view = this,
                    address = addressAutocompleteModel.getCustomerAddress(),
                    place = addressAutocompleteModel.getPlace(),
                    addressData = '',
                    addressDataField = view.$('[name=address-data]');
                if (address) {
                    addressData = address.getData();
                }
                if(place && place.isGooglePlace()){
                    place.fetch();
                }
                addressDataField.parent().toggleClass('input-filled',addressData.length>0);
                addressDataField.val(addressData);
            },
            passwordUpdateSuccess: function (customer, data) {
                app.bottomNotice(t('Votre mot de passe à été mis à jour', 'Account'));
                view.$('.set-password .input').removeClass('input-filled').find('input').val('');
            },
            resetPassword: function (e) {
                e.preventDefault();
                e.stopPropagation();
                var customer = app.getCustomer();
                customer.resetPassword({email: customer.get('email')});
            },

            newAddress: function () {

                view.detachView(addressAutocompleteView);

                addressAutocompleteView = new AddressAutocompleteView({
                    theme: 'modal',
                    type: 'address',
                    action: 'edit',
                    action_context: 'add',
                    autoSubmit: true,
                    displayDelay: false,
                });

                view.attachView(addressAutocompleteView);
                view.listenTo(addressAutocompleteView, 'success', function(){
                    addressAutocompleteView.trigger('close', addressAutocompleteView);
                });

                app.displayModal(addressAutocompleteView);
                addressAutocompleteView.autoFocus();

            },

            toggleInfos: function () {
                view.$('.profile-infos').toggleClass('editable');
            },

            infosFormSubmit: function (e) {
                var view = this,
                    form = view.$('.form-infos'),
                    datas = {},
                    regexPhone = new RegExp(app.c('_REGEX_JAVSCRIPT_PHONE_')),
                    address,
                    customer = app.getCustomer(),
                    addressAutocompleteView = view.addressAutocomplete,
                    addressData = view.$('[name=address-data]').val();
                e.preventDefault();

                //
                function SyncData(model) {
                    var selection = addressAutocompleteView.selection;

                    view.$('.profile-infos').toggleClass('editable', false);

                    //
                    // sauvegarde l'adresse et ses paramètres
                    //
                    addressAutocompleteView.submitSelection(
                        {
                            data: addressData,
                            customer_primary: true
                        }
                    );
                }

                //
                // sauvegarde les données client
                //
                form.serializeArray().forEach(function (o) {
                    datas[o.name] = o.value
                });
                var datasTmp = _(datas).pick('birthday', 'firstname', 'lastname');


                if (app.c('_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER_') == 1) {
                    if (datas.tax_indentification_number != '') {
                        if (!validatorNIF(datas.tax_indentification_number)) {
                            return app.banNotice(t('Merci de rentrer un numéro d\'identification valide', 'Account'));
                        }
                    }
                    datasTmp.tax_indentification_number = datas.tax_indentification_number;
                }

                datas = datasTmp;
                // todo Translation
                if (datas.firstname == '') {
                    app.banNotice(t('Merci de rentrer un prénom valide', 'Account'));
                    return;
                }
                if (datas.lastname == '') {
                    app.banNotice(t('Merci de rentrer un nom valide', 'Account'));
                    return;
                }

                // récupère le champs téléphone au format E164 et le valide.
                datas.phone = phoneUtils.validate(view.$('input[name="phone"]').data('E164'));

                if(!datas.phone){
                    app.banNotice(t('Merci de rentrer un numeros de téléphone valide', 'Account'));
                    return;
                }

                var birthDay = moment(datas.birthday, 'DD/MM/YYYY'),
                    now = moment();

                if (!birthDay.isValid()) {
                    app.banNotice(t('Merci de rentrer une date de naissance valide', 'Account'));
                    return;
                } else if (now.diff(birthDay, 'years') > 130) {
                    app.banNotice(t('Merci de rentrer une date de naissance valide', 'Account'));
                    return;
                } else if (now.diff(birthDay, 'years') < parseInt(app.c('_MIN_YEAR_FORBIDDEN_', 18))) {
                    app.banNotice(t('Vous n\'avez pas l\'âge minimum requis', 'Account'));
                    return;
                }

                view.listenToOnce(customer, 'sync', SyncData);
                customer.save(datas);

                //
            },
            updateAddressPrimary: function () {
                var view = this, customer = app.getCustomer(),
                    primaryAddress = customer.getPrimaryAddress();
                // gère les changement d'adresse
                view.stopListening(null,'change',view.changeAddressPrimary);
                view.listenTo(primaryAddress,'change',view.changeAddressPrimary);
                view.changeAddressPrimary(primaryAddress);
            },
            changeAddressPrimary:function(address){
                var customer = app.getCustomer(),
                    address = customer.displayPrimaryAddress(),
                    addressData = customer.displayPrimaryAddressData();
                view.$('.address-line[data-id_address="' + address.id + '"]').text(address);
                view.$('.field.address-label').text(address);
                view.$('.field.address-data-label').text(addressData);
                view.$("[name=address-data]").val(addressData).parent().toggleClass('input-filled',addressData.length>0);
            },
            updatePhone: function (customer) {
                this.$('.field.phone').text(customer.displayPhone());
            },
            updateMaritalStatus: function (customer) {
                this.$('.field.marital-status').text(customer.displayMaritalStatus());
            },
            updateChildren: function (customer) {
                this.$('.field.children').text(customer.displayChildren());
            },
            updateBirthday: function (customer) {
                this.$('.field.birthday').text(customer.formatBirthday());
            },
            updateStore: function (customer, a, b, c) {
                var shopLikeEl = this.$('.shop-like'),
                    store = customer.getStore();
                shopLikeEl.find('.title').text(store.getFullName());
                shopLikeEl.find('.address').text(store.formatAddress());
                shopLikeEl.find('.link').text(app.t('Modifier', 'UI'));
            },
            updateTaxIdentificationNumber: function (customer, a, b, c) {
                this.$('.field.taxidentificationnumber').text(customer.displayTaxIdentficationNumber());
            },

            addressDelete: function (e) {
                var address = getAddressFromEvent(e);
                if(address){
                    app.confirm(app.t('Voulez-vous supprimez l’adresse','Account'),function(confirm){
                        if(confirm){
                            address.destroy({wait: true});
                        }
                    })
                }
            },
            clickDeliveryAddressAlias:function(e){
                var view = this,
                    address = getAddressFromEvent(e),
                    currentTarget = $(e.currentTarget),
                    parent = currentTarget.closest('.delivery-address-alias__wrapper'),
                    wrapper = parent.find('.address-icon-alias-selector__wrapper');
                wrapper.append('<div class="address-icon-alias-selector__x"></div>');
                view.appendView(AddressIconAliasSelectorView,'.address-icon-alias-selector__x',{type:'account',address:address});
            },
            submitAddressData:function(e){
                var view = this,
                    address = getAddressFromEvent(e),
                    data = $(':text',e.currentTarget).val();
                address.set('data',data);
                address.save();
            },
            updateNoAddress: function () {
                this.$('.addresses .no-result').toggleClass('active', app.getAddresses().size() <= 0);
            },
            addressAdd: function (addressModel) {
                var view = this;
                view.updateNoAddress();
                if(!view.$('.address-list [data-id_address="'+addressModel.id+'"]').get(0)){
                    var addressLine = $(addressLineTemplate({address: addressModel}));
                    view.$('.address-list').append(addressLine);
                }
                view.delegateEvents();
            },
            updateCustomerName: function (customer) {
                this.$('.customer-fullname').text(customer.getFullname());
            },
            addressDestroy: function (addressModel) {
                var view = this,
                    addressLine = view.$('[data-id_address=' + addressModel.id + ']');
                view.updateNoAddress();
                addressLine.slideUp(function(){
                    addressLine.remove();
                });
                view.$('.addresses .no-address').removeClass('active');
            },
            addressChange: function (addressModel) {
                if(addressModel && addressModel.id){
                    var view = this,
                        addressBlock = view.$('[data-id_address="' + addressModel.id + '"]'),
                        data = addressModel.getData();
                    if(!addressBlock.get(0)){
                        view.addressAdd(addressModel);
                    }else{
                        addressBlock.find('.address-data input').val(data);
                        addressBlock.find('.title').html(addressModel.formatIcon() + addressModel.formatAliasLabel());
                    }

                }
            },
            addressError: function (addressModel) {
            },
            onHobbyChange: function (customer, hobby) {
                var view = this,
                    htmlContent = '';
                customer.getHobbies().each(function (hobby) {
                    if (hobby.checked) {
                        htmlContent += profileHobbyTemplate({hobby: hobby, theme: 'list'});
                    }
                });
                view.$('.hobby-list').html(htmlContent);
            },
            toggleOptin: function (e) {
                var currentTarget = e.currentTarget,
                    btn = $(currentTarget),
                    customer = app.getCustomer(),
                    isSms = btn.is('.btn-alert-sms'),
                    parent = btn.closest('.account-item'),
                    icon = parent.find('.round-icon'),
                    active = icon.hasClass('active'),
                    attrBoolType = active ? 'false':'true',
                    newText = btn.data('text-'+attrBoolType),
                    newIcon = btn.data('icon-'+attrBoolType);
                icon.toggleClass('active');
                btn.find('span').text(newText);
                btn.find('i').removeClass().addClass(newIcon);
                TagCommander.eventGA(currentTarget,"Compte","SMS et Newsletter",(active?'des':'')+'active '+(isSms?"SMS":"Newsletter"))
                if(isSms){
                    customer.setSmSAlert();
                }else{
                    customer.setNewsletter();
                }
            },
            toggleHobbies: function () {
                view.$('.hobbies').toggleClass('editable');
            },
            submitHobbies: function (e) {
                e.preventDefault();
                var view = this,
                    datas = {},
                    customer = app.getCustomer(),
                    tcCheckedSlugs = [];

                customer.getHobbies().each(function (hobby) {
                    var isChecked = view.$('[name=' + hobby.slug + ']').is(':checked'),
                        slug = hobby.slug;
                    if(isChecked) tcCheckedSlugs.push(slug);
                    datas[slug] = isChecked;
                });

                TagCommander.eventGA(e.currentTarget,"Compte","Sélection centre d'intérêt",tcCheckedSlugs.join(',')||'None');


                customer.save(datas);
                view.$('.hobbies').removeClass('editable');
            },

            toggleShop: function () {
                view.$('.stores').toggleClass('editable');
            },

            submitShop: function (e) {
                e.preventDefault();
                var view = this,
                    form = view.$('.customer-shop'),
                    datas = {},
                    store,
                    customer = app.getCustomer();
                form.serializeArray().forEach(function (o) {
                    datas[o.name] = o.value
                });

                datas = _(datas).pick('shopLike');
                store = app.getStore(datas.shopLike);
                TagCommander.eventGA(e.currentTarget,"Shops","Shop préféré",store?store.getName():'');

                customer.save(datas);
                view.$('.stores').removeClass('editable');

            },


        });
    });

